import { render, staticRenderFns } from "./ChooseDate.vue?vue&type=template&id=138c1207&scoped=true"
import script from "./ChooseDate.vue?vue&type=script&lang=js"
export * from "./ChooseDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c1207",
  null
  
)

export default component.exports